import * as types from "store/interviewsList/interviewsListTypes";

const initialState = {
  interviewsList: [],
  filteredInterviews: [],
  q: "",
  itemsValues: [],
  filteredItems: new Set(),
  formattedInterviews: [],
  isLoading: false,
  availableModerators: [],
  availableModeratorsLoading: false,
  changeModeratorLoading: false,
  tabs: [
    {
      display: "Upcoming Interviews",
      value: "upcoming",
      active: true,
    },
    {
      display: "Completed Interviews",
      value: "completed",
      active: false,
    },
    {
      display: "Invalidated Interviews",
      value: "invalidate",
      active: false,
    },
  ],
};

const interviewsList = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_INTERVIEWS_LIST_SUCCEEDED:
      return {
        ...state,
        interviewsList: action.payload,
        isLoading: false,
      };

    case types.SET_TABS:
      return {
        ...state,
        tabs: action.payload,
      };
    case types.FETCH_AVAILABLE_MODERATORS_REQUESTED:
      return {
        ...state,
        availableModeratorsLoading: true,
        availableModerators: [],
      };
    case types.FETCH_AVAILABLE_MODERATORS_SUCCEEDED:
      return {
        ...state,
        availableModeratorsLoading: false,
        availableModerators: action.payload,
      };
    case types.FETCH_AVAILABLE_MODERATORS_FAILED:
      return {
        ...state,
        availableModeratorsLoading: false,
        availableModerators: [],
      };
    case types.REASSIGN_MODERATOR_REQUESTED:
      return {
        ...state,
        changeModeratorLoading: true,
      };
    case types.REASSIGN_MODERATOR_SUCCEEDED:
    case types.REASSIGN_MODERATOR_FAILED:
      return {
        ...state,
        changeModeratorLoading: false,
      };
    case types.FETCH_INTERVIEWS_LIST_REQUESTED:
      let isLoading = true;
      let payload = action.payload;
      let offsetUpcoming = 0;
      let offsetCompleted = 0;
      let commun = {
        ...state,
      };
      if (payload && payload.isPMOrAdmin && payload.offset != "undefined") {
        isLoading = false;
        if (payload.flag === "upcoming") {
          offsetUpcoming = state.offsetUpcoming + 25;
          payload.offset = offsetUpcoming;
          return {
            ...commun,
            offsetUpcoming,
          };
        } else if (payload.flag === "completed") {
          offsetCompleted = state.offsetCompleted + 25;
          payload.offset = offsetCompleted;
          return {
            ...commun,
            offsetCompleted,
          };
        }
      }
      return {
        ...commun,
        isLoading,
        offsetUpcoming,
        offsetCompleted,
      };
    case types.SET_FORMATTED_INTERVIEWS:
      let formattedInterviewsAll;
      if (state.offsetUpcoming == 0 && state.offsetCompleted == 0) {
        formattedInterviewsAll = action.payload;
      } else {
        formattedInterviewsAll = [
          ...state.formattedInterviews,
          ...action.payload,
        ];
      }
      return {
        ...state,
        formattedInterviews: formattedInterviewsAll,
        interviewsList: action.payload,
      };
    case types.SET_FILTERED_INTERVIEWS:
      return {
        ...state,
        filteredInterviews: action.payload,
      };
    case types.SET_ITEMS_VALUES:
      return {
        ...state,
        itemsValues: action.payload,
      };
    case types.UPDATE_INTERVIEWS_FILTERS:
      return {
        ...state,
        q: action.payload.q !== undefined ? action.payload.q : state.q,
        filteredItems: action.payload.filteredItems
          ? action.payload.filteredItems
          : state.filteredItems,
      };
    case types.SET_PAYMENT_STATUS_FILTER:
      return {
        ...state,
        paymentStatusCode: action.payload.paymentStatusCode,
      };
    case types.MARK_INVALIDATE_EMAIL_SENT_FOR_TIMESLOT: {
      const timeSlotId = action.payload && action.payload.timeSlotId;
      if (!timeSlotId) return state;
      const updateFlag = (i) =>
        i && i.timeSlotId === timeSlotId
          ? { ...i, isInvalidateEmailSent: true }
          : i;
      return {
        ...state,
        interviewsList: (state.interviewsList || []).map(updateFlag),
        formattedInterviews: (state.formattedInterviews || []).map(updateFlag),
      };
    }
    case types.MARK_INTERVIEW_RESCHEDULED: {
      const timeSlotId = action.payload?.timeSlotId;
      if (!timeSlotId) return state;

      const update = (i) =>
        i.timeSlotId === timeSlotId ? { ...i, isRescheduled: true } : i;

      return {
        ...state,
        interviewsList: state.interviewsList.map(update),
        formattedInterviews: state.formattedInterviews.map(update),
      };
    }
    default:
      return state;
  }
};

export default interviewsList;
